import { render, staticRenderFns } from "./switchLang.vue?vue&type=template&id=96fed926&scoped=true&"
import script from "./switchLang.vue?vue&type=script&lang=js&"
export * from "./switchLang.vue?vue&type=script&lang=js&"
import style0 from "./switchLang.vue?vue&type=style&index=0&id=96fed926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fed926",
  null
  
)

export default component.exports